/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Why_Testimonial_1_RoleInputs */

const es_home_why_testimonial_1_role = /** @type {(inputs: Home_Why_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Director de Operaciones`)
};

const en_home_why_testimonial_1_role = /** @type {(inputs: Home_Why_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operations Director`)
};

/**
* | output |
* | --- |
* | "Operations Director" |
*
* @param {Home_Why_Testimonial_1_RoleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_why_testimonial_1_role = /** @type {((inputs?: Home_Why_Testimonial_1_RoleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Why_Testimonial_1_RoleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_why_testimonial_1_role(inputs)
	return en_home_why_testimonial_1_role(inputs)
});
export { home_why_testimonial_1_role as "home.why.testimonial_1_role" }